<template>
  <div class="drawer-notice">
    <drawer
      :title="'通知信息'"
      v-model="visible"
      :width="'520px'"
      :mask="false"
      @on-visible-change="handleDrawerVisibleChange"
      @on-close="handleClose"
    >
      <div class="global-tools">
        <el-tooltip content="全部已读" :open-delay="tipsDeploy" placement="top">
          <i @click="makeAllRead" class="el-icon-check"></i>
        </el-tooltip>
        <el-tooltip content="删除已读" :open-delay="tipsDeploy" placement="top">
          <i @click="deleteAll" class="el-icon-delete"></i>
        </el-tooltip>
      </div>
      <el-tabs type="border-card" v-model="curTabName">
        <el-tab-pane
          v-for="noticeGroup in noticeGroups"
          :key="noticeGroup.name"
          :name="noticeGroup.name"
        >
          <span slot="label">
            {{ noticeGroup.text }}
            <el-badge
              v-if="noticeGroup.name === 'unread' && unreadNum > 0"
              class="mark left-space"
              :value="unreadNum"
            ></el-badge>
          </span>
          <notice-panel
            v-loading="loading"
            :noticeList="noticeList"
            :hasMore="hasMore"
            :loadingMore="loadingMore"
            @notice-status-change="handleNoticeStatusChange"
            @load-more="handleLoadMore"
          >
          </notice-panel>
        </el-tab-pane>
      </el-tabs>
    </drawer>
  </div>
</template>
<script>
  import Drawer from '../drawer/drawer'
  import config from './config'
  import util from '../../libs/util'
  import NoticePanel from './notice-panel'
  import ws from '../../websocket'
  export default {
    name: 'drawer-notice',
    components: {NoticePanel, Drawer},
    props: {
    },
    data() {
      return {
        loading: false,
        loadingMore: false,
        visible: false,
        curTabName: 'all',
        startIndex: 0,
        noticeList: [],
        hasMore: false,
        unreadNum: 0,
        wsChannel: 'serverNotice',
        tipsDeploy: 300
      }
    },
    computed: {
      drawerStyle: function () {
        return {
          left: (this.$store.state.app.showLeftMenu ? 251 : 0) + 'px'
        }
      },
      noticeGroups: function () {
        return config.noticeGroups
      }
    },
    created() {
      this.queryUnreadNum()
      // handle `esc` key
      window.addEventListener('keydown', evt => {
        if (evt.keyCode === 27 && this.visible) {
          this.hide()
        }
      })
    },
    mounted() {
      ws.registerObserver(this.wsChannel, this)
    },
    beforeDestroy() {
      ws.removeObserver(this.wsChannel, this)
    },
    methods: {
      show() {
        this.visible = true
      },
      hide() {
        this.visible = false
      },
      toggle() {
        this.visible = !this.visible
      },
      onMessage(data) {
        if (this.curTabName === 'all' || this.curTabName === 'unread') {
          this.noticeList.unshift(data.data)
        }
        this.unreadNum++
        this.$notify({
          title: '消息',
          message: '您有一条新通知！',
          position: 'bottom-left'
        })
      },
      // drawer关闭时触发
      handleClose() {
        this.$emit('close')
      },
      // drawer显示时重新加载数据
      handleDrawerVisibleChange(visible) {
        if (visible) {
          this.loadFirstPage()
        }
      },
      queryUnreadNum() {
        util.ajax.post('/core/serverNotice/queryUnreadNum').then(res => {
          if (res.data.meta.errCode === 0) {
            this.unreadNum = res.data.data
            if (this.unreadNum > 0) {
              this.$notify({
                title: '消息',
                message: '您有 ' + this.unreadNum + ' 条新通知！',
                position: 'bottom-left'
              })
            }
          }
        }).catch(err => {
          console.error(err)
        })
      },
      loadFirstPage() {
        this.startIndex = 0
        this.noticeList = []
        this.loading = true
        this.loadNotice()
      },
      loadNotice() {
        let params = {
          type: this.curTabName,
          startIndex: this.startIndex,
          pageSize: config.pageSize
        }
        let onCurTabName = this.curTabName
        util.ajax.post('/core/serverNotice/notice', {params}).then(res => {
          if (onCurTabName === this.curTabName) { // 如果tab已经切换，则不处理返回结果
            this.loading = false
            this.loadingMore = false
            if (res.data.meta.errCode === 0) {
              this.noticeList = [...this.noticeList, ...res.data.data.noticeList]
              this.hasMore = res.data.data.hasMore
              this.startIndex += config.pageSize
            } else {
              this.$notify.error({title: '错误', message: '加载通知信息失败！' + res.data.meta.errMsg})
            }
          }
        }).catch(err => {
          if (onCurTabName === this.curTabName) { // 如果tab已经切换，则不处理返回结果
            this.loading = false
            this.loadingMore = false
            console.error(err)
            this.$notify.warning({title: '错误', message: '加载通知信息失败！'})
          }
        })
      },
      handleLoadMore() {
        this.loadingMore = true
        this.loadNotice()
      },
      handleNoticeStatusChange(notice, status) {
        if (status === 'read') {
          this.markNoticeRead(notice)
        } else if (status === 'star') {
          this.markNoticeStar(notice)
        } else if (status === 'unstar') {
          this.markNoticeUnstar(notice)
        } else if (status === 'delete') {
          this.markNoticeDelete(notice)
        }
        let params = {
          noticeId: notice.id,
          status: status
        }
        util.ajax.post('/core/serverNotice/updateNoticeStatus', {params}).then(res => {
          if (res.data.meta.errCode === 0) {
          } else {
            this.$notify.error({title: '错误', message: '修改状态失败！' + res.data.meta.errMsg})
          }
        }).catch(err => {
          console.error(err)
          this.$notify.warning({title: '错误', message: '修改状态失败！'})
        })
      },
      markNoticeRead(notice) {
        this.$set(notice, 'read', true)
        this.unreadNum--
        // 如果当前位于未读列表，则将notice从列表中移除
        if (this.curTabName === 'unread') {
          this.removeNoticeFromList(notice)
        }
      },
      markNoticeStar(notice) {
        this.$set(notice, 'star', true)
      },
      markNoticeUnstar(notice) {
        this.$set(notice, 'star', false)
        // 如果当前位于星标列表，则将notice从列表移除
        if (this.curTabName === 'star') {
          this.removeNoticeFromList(notice)
        }
      },
      markNoticeDelete(notice) {
        this.$set(notice, 'delete', false)
        if (!notice.read) {
          this.unreadNum--
        }
        this.removeNoticeFromList(notice)
      },
      removeNoticeFromList(notice) {
        for (let i = 0; i < this.noticeList.length; i++) {
          if (this.noticeList[i].id === notice.id) {
            this.noticeList.splice(i, 1)
            break
          }
        }
      },
      makeAllRead() { // 全部已读
        this.unreadNum = 0
        for (let i = 0; i < this.noticeList.length; i++) {
          this.$set(this.noticeList[i], 'read', true)
        }
        // 更新数据库
        util.ajax.post('/core/serverNotice/updateAllRead').then(res => {
          if (res.data.meta.errCode === 0) {
          } else {
            this.$notify.error({title: '错误', message: '操作失败！' + res.data.meta.errMsg})
          }
        }).catch(err => {
          console.error(err)
          this.$notify.warning({title: '错误', message: '操作失败！'})
        })
      },
      deleteAll() { // 删除全部
        this.unreadNum = 0
        this.noticeList = []
        // 更新数据库
        util.ajax.post('/core/serverNotice/deleteAll').then(res => {
          if (res.data.meta.errCode === 0) {
          } else {
            this.$notify.error({title: '错误', message: '操作失败！' + res.data.meta.errMsg})
          }
        }).catch(err => {
          console.error(err)
          this.$notify.warning({title: '错误', message: '操作失败！'})
        })
      }
    },
    watch: {
      'curTabName': function () {
        this.loadFirstPage()
      },
      'unreadNum': function (newValue) {
        this.$emit('unread-notice-num-change', newValue)
      }
    }
  }
</script>
<style lang="scss">
  .drawer-notice {
    .global-tools {
      display: flex;
      flex: 0 0 auto;
      position: absolute;
      z-index: 2000;
      right: 60px;
      top: 10px;

      i {
        font-size: 20px;
        line-height: 20px;
        cursor: pointer;
        color: #383838;
        margin-left: 16px;
        &.el-icon-star-on {
          color: #666666;
        }
      }
      i:hover {
        color: #3da8f5;
        font-size: 22px;
        margin-left: 14px;
      }
    }
    .ivu-drawer-wrap, .ivu-drawer {
      top: 60px;
      right: 0;
    }
    .ivu-drawer-body {
      padding: 0;
    }
    .el-tabs {
      border: none;
      box-shadow: none;
      height: 100%;
      overflow: hidden;
    }
    .el-tabs__content {
      padding: 0;
      height: calc(100% - 39px);
      overflow: hidden;
    }
    .el-tab-pane {
      height: 100%;
      overflow: auto;
    }
  }
  .quick-view-notice {
    color: blue;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/drawer-notice/drawer-notice.vue